import { render, staticRenderFns } from "./fiveMinistries.vue?vue&type=template&id=100b8aca&scoped=true"
import script from "./fiveMinistries.vue?vue&type=script&lang=js"
export * from "./fiveMinistries.vue?vue&type=script&lang=js"
import style0 from "./fiveMinistries.vue?vue&type=style&index=0&id=100b8aca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b8aca",
  null
  
)

export default component.exports